import "react-app-polyfill/ie9";
import React from "react";
import App from "./App";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.min.css";

// Redux
import { createStore } from "redux";
import { Provider } from "react-redux";
import rootReducers from "./reducers/reducers";

// Apollo
import { ApolloProvider } from "react-apollo";
import client from "./apollo-client";

// Redux
export const store = createStore(
  rootReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>,
  document.getElementById("root")
);
